import { IPageSettings } from "../src/taskpane/interfaces/IPageSettings";

class SavingLocationStructureModule {
    private savingLocationStructure: IPageSettings[];

    setSavingLocationStructure(savingLocations: IPageSettings[]): void {
        this.savingLocationStructure = savingLocations ? [...savingLocations] : null;
    }

    getSavingLocationStructure(): IPageSettings[] {
        return this.savingLocationStructure;
    }

    getSavingDestination(): IPageSettings {
        return this.savingLocationStructure ? this.savingLocationStructure[this.savingLocationStructure.length - 1] : null;
    }

    addSavingLocationStructure(savingLocation: IPageSettings): void {
        if (savingLocation) {
            this.savingLocationStructure = this.savingLocationStructure ? this.savingLocationStructure.concat(savingLocation) : [savingLocation];
        }
    }
}

const savingLocationStructureModule = new SavingLocationStructureModule();
export default savingLocationStructureModule;